"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFavoritesLinkAndText = void 0;
var _context = require("../context");
var _models = require("../models");
var _useTranslations = require("./useTranslations");
// istanbul ignore file -- Temporary solution

const useFavoritesLinkAndText = () => {
  const {
    favoriteListsEnabled
  } = (0, _context.useAppConfig)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return {
    favoritesLink: favoriteListsEnabled ? _models.FavoriteListsLink : _models.FavoritesLink,
    favoritesText: favoriteListsEnabled ? translations.favouriteLists : translations.myFavoriteProducts
  };
};
exports.useFavoritesLinkAndText = useFavoritesLinkAndText;
//# sourceMappingURL=useFavoritesLinkAndText.js.map